import {Base} from "@/api/Base"

export class SalaryInformationEdit extends Base {
    path = "salaryInformation/edit"
}